<template>
  <div class="overhead-desktop__wrapper">
    <overhead-window
      v-for="item in getOverheadLayout"
      :item="item"
      :key="item.i"
    />
  </div>
</template>

<script>
import OverheadWindow from "./overhead-window";

export default {
  components: {
    OverheadWindow
  },
  computed: {
    getOverheadLayout() {
      return this.$store.state.interface.overheadLayout;
    }
  }
};
</script>

<style></style>
